import { ChromaContext } from '@iag-packages/chroma-react/lib/components';
import React, { useContext, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import {
  ContextProvider,
  useFunnelState,
} from 'scenes/common/contexts/quoteFlowContext';
import { FunnelType } from 'scenes/common/flows/types';
import HomeFullPage from 'scenes/home/components/FullPage';
import { homeReducer } from 'scenes/home/flows';
import { initialHomeFunnelState } from 'scenes/home/flows/initialHomeFunnelState';
import LandlordFullPage from 'scenes/landlord/components/FullPage';
import { landlordReducer } from 'scenes/landlord/flows';
import { initialLandlordFunnelState } from 'scenes/landlord/flows/initialLandlordFunnelState';
import MotorFullPage from 'scenes/motor/components/FullPage';
import { motorReducer } from 'scenes/motor/flows';
import { initialMotorFunnelState } from 'scenes/motor/flows/initialMotorFunnelState';
import RetrieveFullPage from 'scenes/retrieve/components/FullPage/RetrieveFullPage';
import { RetrieveFunnelState } from 'scenes/retrieve/flows/types';
import config, { isStopFunnels } from 'shared/config';
import { ChromaContextType } from './common/types';
import ImportantUpdateFullPage from './importantUpdate/FullPage';
import ScheduledMaintenanceFullPage from './outage/components/FullPage/ScheduledMaintenanceFullPage';
import { PaymentContextProvider } from './payments/paymentContext';
import PaymentFullPage from './payments/PaymentFullPage';
import NotFoundFullPage from './notFoundPage/FullPage';
import TermsAndConditions from './termsAndConditions/FullPage/TermsAndConditions';

const FunnelRouter = () => {
  const retrieveFlowState = useFunnelState<RetrieveFunnelState>();
  const { setBrand } = useContext<ChromaContextType>(ChromaContext);

  useEffect(() => {
    setBrand('coles');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Switch>
      {!isStopFunnels() && (
        <Route path={`/:productType(${FunnelType.Retrieve})`}>
          <RetrieveFullPage />
        </Route>
      )}

      {!isStopFunnels() && (
        <Route path={`/:productType(${FunnelType.Outage})`}>
          <ScheduledMaintenanceFullPage />
        </Route>
      )}

      {!isStopFunnels() && (
        <Route path={`/:productType(${FunnelType.Motor})`}>
          <ContextProvider
            initialFunnelState={initialMotorFunnelState(
              retrieveFlowState.apiResponses.motorQuoteDetails
            )}
            reducer={motorReducer}
          >
            <MotorFullPage />
          </ContextProvider>
        </Route>
      )}

      {!isStopFunnels() && (
        <Route path={`/:productType(${FunnelType.Home})`}>
          <ContextProvider
            initialFunnelState={initialHomeFunnelState(
              retrieveFlowState.apiResponses.homeQuoteDetails
            )}
            reducer={homeReducer}
          >
            <HomeFullPage />
          </ContextProvider>
        </Route>
      )}

      {!isStopFunnels() && config.featureToggles.landlord === 'ON' && (
        <Route path={`/:productType(${FunnelType.Landlord})`}>
          <ContextProvider
            initialFunnelState={initialLandlordFunnelState(
              retrieveFlowState.apiResponses.landlordQuoteDetails
            )}
            reducer={landlordReducer}
          >
            <LandlordFullPage />
          </ContextProvider>
        </Route>
      )}

      {config.featureToggles.paymentPortal === 'ON' && (
        <Route path={`/:productType(${FunnelType.Payment})`}>
          {/** TODO add renewal state management */}
          <PaymentContextProvider>
            <PaymentFullPage />
          </PaymentContextProvider>
        </Route>
      )}
      <Route path="/termsandconditions">
        <TermsAndConditions />
      </Route>
      <Route>
        {isStopFunnels() ? <ImportantUpdateFullPage /> : <NotFoundFullPage />}
      </Route>
    </Switch>
  );
};

export default FunnelRouter;
